/**
 * 앱 전역 설정 Store
 * 패스코드, 알림 설정 등 앱 전반적인 설정을 관리합니다.
 */

import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface NotificationSettings {
  notice: boolean
  mission: boolean
  chat: boolean
}

interface AppStore {
  // 패스코드
  appPassword: string | null
  setAppPassword: (password: string | null) => void
  clearAppPassword: () => void
  hasAppPassword: () => boolean

  // 알림 설정
  notificationSettings: NotificationSettings
  setNotificationSettings: (settings: NotificationSettings) => void
  updateNotificationSetting: (key: keyof NotificationSettings, value: boolean) => void
}

export const useAppStore = create<AppStore>()(
  persist(
    (set, get) => ({
      // 패스코드 초기값
      appPassword: null,

      // 패스코드 설정
      setAppPassword: (password: string | null) => {
        set({ appPassword: password })
      },

      // 패스코드 삭제
      clearAppPassword: () => {
        set({ appPassword: null })
      },

      // 패스코드 설정 여부 확인
      hasAppPassword: () => {
        return get().appPassword !== null
      },

      // 알림 설정 초기값
      notificationSettings: {
        notice: true,
        mission: true,
        chat: true
      },

      // 알림 설정 전체 변경
      setNotificationSettings: (settings: NotificationSettings) => {
        set({ notificationSettings: settings })
      },

      // 알림 설정 개별 변경
      updateNotificationSetting: (key: keyof NotificationSettings, value: boolean) => {
        set(state => ({
          notificationSettings: {
            ...state.notificationSettings,
            [key]: value
          }
        }))
      }
    }),
    {
      name: 'app-settings', // localStorage 키
      storage: createJSONStorage(() => localStorage)
    }
  )
)
